document.addEventListener("DOMContentLoaded", function () {
  const resultWrap = document.querySelector(".pharmacy-result-wrap");

  if (resultWrap) {
    // Intercept the copy event
    resultWrap.addEventListener("copy", function (e) {
      e.preventDefault(); // Prevent the default copy behavior

      // Extract both text and HTML content from `.location` elements
      const locationElements = Array.from(resultWrap.querySelectorAll(".location"));
      
      // Extract clean text and HTML from each `.location`
      const textContent = locationElements
        .map((location) => location.innerText.trim())
        .join("\n\n"); // Join text with newlines between locations

      const htmlContent = locationElements
        .map((location) => location.outerHTML.trim())  // Use outerHTML for HTML content
        .join("<br><br>");  // Join HTML with <br> tags for separation

      // Set both text and HTML content into the clipboard (Safari compatible)
      e.clipboardData.setData("text/plain", textContent);  // Text format
      e.clipboardData.setData("text/html", htmlContent);   // HTML format
    });
  }
});
